// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Argonaut_Decode_Class from "../Data.Argonaut.Decode.Class/index.js";
import * as Data_Argonaut_Encode_Class from "../Data.Argonaut.Encode.Class/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Time_Duration from "../Data.Time.Duration/index.js";
import * as Fusion_Data_Bytes from "../Fusion.Data.Bytes/index.js";
import * as Fusion_Data_Duration from "../Fusion.Data.Duration/index.js";
import * as Test_QuickCheck_Arbitrary from "../Test.QuickCheck.Arbitrary/index.js";
import * as Test_QuickCheck_Gen from "../Test.QuickCheck.Gen/index.js";
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showNumber);
var pure = /* #__PURE__ */ Control_Applicative.pure(Test_QuickCheck_Gen.applicativeGen);
var bind = /* #__PURE__ */ Control_Bind.bind(Data_Either.bindEither);
var decodeJson = /* #__PURE__ */ Data_Argonaut_Decode_Class.decodeJson(Data_Argonaut_Decode_Class.decodeJsonNumber);
var pure1 = /* #__PURE__ */ Control_Applicative.pure(Data_Either.applicativeEither);
var eq = /* #__PURE__ */ Data_Eq.eq(Fusion_Data_Duration.eqDuration);
var mempty = /* #__PURE__ */ Data_Monoid.mempty(Fusion_Data_Duration.monoidDuration);
var convertDuration = /* #__PURE__ */ Data_Time_Duration.convertDuration(Fusion_Data_Duration.durationDuration)(Data_Time_Duration.durationSeconds);
var Speed = function (x) {
    return x;
};
var showSpeed = {
    show: function (v) {
        return "(Speed.fromBps " + (show(v) + ")");
    }
};
var semigroupSpeed = {
    append: function (v) {
        return function (v1) {
            return v + v1;
        };
    }
};
var ordSpeed = Data_Ord.ordNumber;
var monoidSpeed = {
    mempty: 0,
    Semigroup0: function () {
        return semigroupSpeed;
    }
};
var eqSpeed = Data_Eq.eqNumber;
var defaultSpeed = {
    def: 0
};
var arbitrarySpeed = {
    arbitrary: /* #__PURE__ */ Control_Bind.bind(Test_QuickCheck_Gen.bindGen)(/* #__PURE__ */ Test_QuickCheck_Arbitrary.arbitrary(Test_QuickCheck_Arbitrary.arbNumber))(function (num) {
        return pure(num);
    })
};
var toOld = function (v) {
    return v * 1.0e-9;
};
var toBps = function (v) {
    return v;
};
var encodeJsonSpeed = {
    encodeJson: /* #__PURE__ */ (function () {
        var $45 = Data_Argonaut_Encode_Class.encodeJson(Data_Argonaut_Encode_Class.encodeJsonJNumber);
        return function ($46) {
            return $45(toBps($46));
        };
    })()
};
var scale = function (f) {
    return function (v) {
        return f * v;
    };
};
var fromOld = function (v) {
    return v * 1.0e9;
};
var fromBps = function (bps) {
    return bps;
};
var decodeJsonSpeed = {
    decodeJson: function (json) {
        return bind(decodeJson(json))(function (num) {
            return pure1(fromBps(num));
        });
    }
};
var bytesPerDuration = function (bytes) {
    return function (duration) {
        var $43 = eq(duration)(mempty);
        if ($43) {
            return 0;
        };
        var v = convertDuration(duration);
        return (Fusion_Data_Bytes.toNumber(bytes) / v) * 8.0;
    };
};
export {
    bytesPerDuration,
    fromBps,
    fromOld,
    scale,
    toBps,
    toOld,
    semigroupSpeed,
    monoidSpeed,
    eqSpeed,
    ordSpeed,
    showSpeed,
    encodeJsonSpeed,
    decodeJsonSpeed,
    arbitrarySpeed,
    defaultSpeed
};
